/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import t from '@services/locale';

import { Box, Text } from '@components/atoms';
import { CustomContainer, Slider } from '@components/molecules';

const GUTForm = ({
    control, formState: { errors }, questions,
}) => (
    <>
        {questions.map((item, index) => {
            if (item.field === 'SUBHEADING') {
                return (
                    <Box key={`subheading-${index}`} mb="3vh" mt="6vh">
                        <Text bold color="purple" fontSize={22}>
                            {item.statement}
                        </Text>
                        {item.context && (
                        <Text color="grey.600" fontSize={14} mt="1vh">
                            {item.context}
                        </Text>
                        )}
                    </Box>
                );
            }

            if (item.field === 'GUT_TRIPLET') {
                return (
                    <CustomContainer bgColor="white" key={`triplet-${index}`} mb="4vh" p="2rem">
                        <Box display="flex" flexDirection="column" p="1rem" width="100%">
                            <Text bold fontSize={18} mb="1vh">
                                {item.statement}
                            </Text>
                            {item.context && (
                            <Text color="grey.700" fontSize={15} mb="2vh">
                                {item.context}
                            </Text>
                            )}

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                gap="2rem"
                                justifyContent="space-between"
                                mt="3vh"
                            >
                                {[
                                    { key: 'gravity', label: t('Gravidade') },
                                    { key: 'urgency', label: t('Urgência') },
                                    { key: 'tendency', label: t('Tendência') },
                                ].map((group) => {
                                    const questionIndex = item[group.key].num_order - 1;

                                    return (
                                        <Box
                                            display="flex"
                                            flex={1}
                                            flexDirection="column"
                                            key={group.key}
                                            minWidth="150px"
                                        >
                                            <Text bold color="grey.800" fontSize={14} mb="1vh">
                                                {group.label}
                                            </Text>

                                            <Slider
                                                control={control}
                                                error={errors?.answers?.[questionIndex]?.answer?.message}
                                                max={5}
                                                max_label={t('Alta')}
                                                min={1}
                                                min_label={t('Baixa')}
                                                name={`answers.${questionIndex}.answer`}
                                                steps={4}
                                                type="discrete"
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>
                    </CustomContainer>
                );
            }

            return null;
        })}
    </>
);

GUTForm.propTypes = {
    control: PropTypes.shape({
        register: PropTypes.func,
    }).isRequired,
    formState: PropTypes.shape({
        errors: PropTypes.shape({
            answers: PropTypes.arrayOf(
                PropTypes.shape({
                    answer: PropTypes.shape({
                        message: PropTypes.string,
                    }),
                }),
            ),
        }),
    }).isRequired,
    questions: PropTypes.arrayOf(PropTypes.shape({
        context: PropTypes.string,
        field: PropTypes.string,
        gravity: PropTypes.object,
        statement: PropTypes.string,
        tendency: PropTypes.object,
        urgency: PropTypes.object,
        visibility_rule: PropTypes.shape({
            type: PropTypes.string,
        }),
    })).isRequired,
};

export default GUTForm;
